module.exports = __webpack_public_path__ + "static/media/029.805d940e.jpg";